import notifications from '../data/notifications/notifications.json';

export const getAllNotifications = () => {
  return notifications.notifications;
};
